import { type GetRetailerRegionQuery, useGetRetailerRegionQuery } from '@vizit/api';
import { useAuth } from '@vizit/auth';

/**
 * Return type for the useRetailerRegion hook
 */
interface UseRetailerRegionReturn {
  /**
   * The retailer region data
   */
  data: GetRetailerRegionQuery | undefined;
  /**
   * Whether the retailer region data is loading
   */
  isLoading: boolean;
  /**
   * Any error that occurred
   */
  error: unknown;
}

/**
 * Hook to fetch retailer region data using the default_retailer from auth context
 *
 * @returns The retailer region data and loading states
 */
export const useRetailerRegion = (): UseRetailerRegionReturn => {
  const { defaultRetailer } = useAuth();

  const { data, isLoading, error } = useGetRetailerRegionQuery(
    {
      retailer_region_id: defaultRetailer ?? '',
    },
    {
      enabled: !!defaultRetailer,
    },
  );

  return {
    data,
    isLoading,
    error: error || null,
  };
};
